module.exports = __webpack_public_path__ + "img/M858.6c27d7db.jpg";